var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext } from 'react';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';
import { getNotificationTitle } from '../utils/getNotificationTitle';
export var NotificationContext = createContext(null);
export var NotificationProvider = function (_a) {
    var children = _a.children;
    toastr.options = {
        positionClass: 'toast-custom-position'
    };
    var liveNotification = function (type, message, title) {
        var notificationTitle = getNotificationTitle(title, type);
        toastr[type](message, notificationTitle);
    };
    return (_jsx(NotificationContext.Provider, __assign({ value: { liveNotification: liveNotification } }, { children: children })));
};
